module.exports = flarum.core.compat['common/models/Group'];